import { Chart, Tooltip as tooltipPlugin } from 'chart.js';

let patched = false;

function resolveTooltipClass() {
  // Chart.js exports the tooltip *plugin* as `Tooltip`; the DOM class is `_element`.
  return tooltipPlugin?._element || null;
}

/**
 * Chart.js tooltip can call getParsed() on a null controller when hover state
 * outlives a chart re-init (PrimeVue Chart reinit on data/options watch).
 */
function patchTooltipActiveElements() {
  if (patched) return;

  const TooltipClass = resolveTooltipClass();
  const original = TooltipClass?.prototype?._getActiveElements;
  if (typeof original !== 'function') return;

  patched = true;

  TooltipClass.prototype._getActiveElements = function safeGetActiveElements(
    event,
    lastActive,
    replay,
    inChartArea,
  ) {
    if (!inChartArea) {
      return lastActive.filter((item) => {
        const datasets = this.chart?.data?.datasets;
        if (!datasets?.[item.datasetIndex]) return false;

        const controller = this.chart.getDatasetMeta(item.datasetIndex)?.controller;
        if (!controller) return false;

        try {
          return controller.getParsed(item.index) !== undefined;
        } catch {
          return false;
        }
      });
    }

    return original.call(this, event, lastActive, replay, inChartArea);
  };
}

/** Clears stale tooltip state before chart update / destroy. */
export const chartLifecyclePlugin = {
  id: 'crcChartLifecycle',
  beforeUpdate(chart) {
    if (chart.tooltip?._active?.length) {
      chart.tooltip._active = [];
    }
  },
  destroy(chart) {
    if (chart.tooltip?._active?.length) {
      chart.tooltip._active = [];
    }
  },
  beforeEvent(chart) {
    if (!chart.canvas?.isConnected) {
      return false;
    }
    return undefined;
  },
};

export function installChartJsTooltipGuard() {
  patchTooltipActiveElements();
  Chart.register(chartLifecyclePlugin);
}
